import React, { Component } from 'react';
import Dialog from 'containers/dialog';
import ReactMarkdown from 'react-markdown';
import Http from 'utils/http';
import CodeBlock from "./CodeBlock";
import "./MarkdownDialog.scss";

class MarkdownDialog extends Component {

  constructor(props) {
    super(props);

    this.state = {
      visible: false,
      isLoading: false,
      title: '',
      markdown: ''
    };

    this.resolve = null;
  }

  getContent(fileName) {
    let markdownFile = this.getContext(fileName);
    return Http.getLocalResource('docs/' + markdownFile + ".md");
  }

  getTitle(fileName) {
    let title = this.getContext(fileName) + " Documentation";
    return this.titleCase(title.replace(/-/g, " "));
  }

  titleCase(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    return splitStr.join(' ');
  }

  getContext(fileName) {
    let markdown = "home";

    if (fileName) {
      markdown = fileName;
    }
    return markdown;
  }

  show(files) {
    if (!Array.isArray(files)) {
      files = [files];
    }

    return new Promise(resolve => {
      this.resolve = resolve;

      this.setState({
        visible: true,
        isLoading: true,
        title: this.getTitle(files[0])
      });

      let promises = files.map((file) => this.getContent(file));

      Promise.all(promises).then(datas => {

        let concat = datas.reduce((accumulator, value) => accumulator ? `${accumulator}\n\n_____\n\n${value}` : value, '');

        this.setState({
          isLoading: false,
          markdown: concat
        });
      });
    });

  }

  hide() {
    this.setState({
      visible: false
    })
  }

  render() {

    return (
      <Dialog
        show={this.state.visible}
        title={this.state.title}
        onConfirm={this.hide.bind(this)}
        confirm="Close"
        size="medium"
        cancelButton={() => { return (<div />) }}
        className="markdown"
      >
        {this.state.isLoading && (
          <div className="text-center">
            <span className="spinner-border text-primary"></span>
          </div>
        )}
        <ReactMarkdown source={this.state.markdown} renderers={{ code: CodeBlock }} />
      </Dialog>
    );
  }

}

export default MarkdownDialog;
